module.exports = __webpack_public_path__ + "img/favorite_border_24px.b7d60e03.svg";